export type Me = { id: number; email: string; displayName: string | null };
export type Progress = {
  completed: string[];
  journal: Record<string, Record<string, string>>;
};

async function req<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    credentials: 'same-origin',
    headers: init?.body ? { 'Content-Type': 'application/json' } : undefined,
    ...init,
  });
  if (!res.ok) {
    let payload: unknown;
    try { payload = await res.json(); } catch { /* ignore */ }
    const err = new Error(`HTTP ${res.status}`) as Error & { status: number; payload?: unknown };
    err.status = res.status;
    err.payload = payload;
    throw err;
  }
  return (await res.json()) as T;
}

export const api = {
  me: () => req<Me>('/api/me'),
  signup: (body: { email: string; password: string; displayName?: string }) =>
    req<Me>('/api/auth/signup', { method: 'POST', body: JSON.stringify(body) }),
  login: (body: { email: string; password: string }) =>
    req<Me>('/api/auth/login', { method: 'POST', body: JSON.stringify(body) }),
  logout: () => req<{ ok: true }>('/api/auth/logout', { method: 'POST' }),
  progress: () => req<Progress>('/api/progress'),
  markComplete: (slug: string) =>
    req<{ ok: true }>(`/api/progress/${slug}/complete`, { method: 'PUT' }),
  unmarkComplete: (slug: string) =>
    req<{ ok: true }>(`/api/progress/${slug}/complete`, { method: 'DELETE' }),
  saveJournal: (slug: string, promptKey: string, content: string) =>
    req<{ ok: true }>(`/api/journal/${slug}/${promptKey}`, {
      method: 'PUT',
      body: JSON.stringify({ content }),
    }),
};
